import { supabase } from "@/integrations/supabase/client";

/**
 * Records a successful upload for rate limiting purposes.
 * The database policies enforce a 30 uploads per 24 hour limit per user.
 */
export const recordUpload = async (bucketId: string, fileName: string) => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  try {
    await supabase.rpc('record_upload', {
      p_user_id: user.id,
      p_bucket_id: bucketId,
      p_file_name: fileName
    });
  } catch (error) {
    // Non-critical - tracking failure shouldn't block the user
    console.warn('Failed to record upload for rate limiting:', error);
  }
};

/**
 * Checks if the current user can upload more files (under 30/24hr limit).
 */
export const canUpload = async (): Promise<boolean> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;

  try {
    const { data, error } = await supabase.rpc('check_upload_rate_limit', {
      p_user_id: user.id
    });
    
    if (error) {
      console.warn('Failed to check upload rate limit:', error);
      return true; // Allow upload if check fails
    }
    
    return data === true;
  } catch (error) {
    console.warn('Failed to check upload rate limit:', error);
    return true;
  }
};
